import { makeToast } from './makeToast';
import { getServerErrorText } from './getServerErrorText';

export function handleServerErrorWithToast({ payload }) {
  const message = getServerErrorText(payload);
  makeToast('error', message);
}



// WEBPACK FOOTER //
// ./src/utils/ui/handleServerErrorsWithToast.js